import { useContext, useEffect, useState } from "react";
import { UnseContext } from "../context/UnseContext";
import $ from "jquery";
import { Link } from "react-router-dom";




export default function UnseResult({Loading, Constellation }) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    const memberId = localStorage.getItem('memberId');
    const unseLogId = localStorage.getItem('unseLogId');
    const [data, setData] = useState([]);
    const siteCode = process.env.REACT_APP_SITE_CODE;
    
    useEffect(() => {
        if(unseLogId && memberId) {
            $.ajax({
                url: `${API_BASE_URL}/getUnseResult`,
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify({
                    "member_id": memberId,
                    "unse_log_id": unseLogId,
                    "site_code": siteCode
                }),
                cache: false,
                headers: {
                    APIKEY: APIKEY,
                },
                success: function (res) {
                    // console.log(res);
                    if (res.code != "0") {
                        alert(res.msg); return false;
                    }
                    setData(res);
                    // console.log("응답:", res);
                },
                error: function (xhr, status, err) {
                    console.error("에러:", err);
                    // console.log("상태:", xhr.status, "응답:", xhr.responseText);
                },
            });
        } else {
            alert("잘못된 접근입니다.");
            window.location.href="/";
        }
        
    },[]);

    if (!data) {
        return <Loading Constellation={Constellation}/>;
    } 

    return (
        <div className="UnseResultPage_inner">
            <div className="UnseResultContent">
                <h4 className="userInfo">
                    {data.title}
                </h4>
                <h3 className="subTitle">{data.subtitle}</h3>
                <div className="unseResultText" dangerouslySetInnerHTML={{__html: data.result}}
                />
            </div>
            <Link to="/FortuneList" className="unseListBtn">당신의 또 다른 운세가 궁금하다면?</Link>
        </div>
    )
}